module.exports = __webpack_public_path__ + "assets/0.1.11/img/loginLeft.48826cde.png";